
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "RecebimentoParcialModal",
  components: {
    Money,
  },
  mixins: [SistemaMixin],
  props: {
    modalId: {
      type: String,
      default: "receberParcial",
    },
    conta: {
      type: Object,
      default: null,
    },
    bancos: {
      type: Array,
      default: () => [],
    },
    meiosPagamentos: {
      type: Array,
      default: () => [],
    },
    recebimentoPdv: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valorParcial: 0,
      dataRecebimentoParcial: null,
      dataVencimentoParcial: null,
      contaParcial: null,
      meioPagamentoParcial: null,
      descontoParcial: false,
      isSubmitting: false,
      configMask: settingMoney,
      dateFormatOptions: {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      },
    };
  },
  computed: {
    contaAtual() {
      return this.conta || {};
    },
    valorTotal() {
      const valorTotal = parseFloat(this.conta?.valor_total || 0);
      return valorTotal > 0 ? valorTotal : parseFloat(this.conta?.valor || 0);
    },
    valorRestante() {
      return Math.max(this.valorTotal - Number(this.valorParcial || 0), 0);
    },
  },
  watch: {
    valorParcial(newValue) {
      if (newValue > this.valorTotal) {
        this.valorParcial = this.valorTotal;
      }
    },
  },
  methods: {
    prepararModal(event) {
      if (!this.conta?.id) {
        event?.preventDefault();
        this.$toast.error(
          "Selecione uma conta em aberto para receber parcialmente."
        );
        return;
      }

      this.dataVencimentoParcial = this.conta.data_vencimento;
      this.contaParcial = this.contaParcial || this.bancos[0] || null;
      this.meioPagamentoParcial =
        this.meioPagamentoParcial || this.meiosPagamentos[0] || null;
    },
    reset() {
      if (this.isSubmitting) return;

      this.valorParcial = 0;
      this.dataRecebimentoParcial = null;
      this.dataVencimentoParcial = null;
      this.contaParcial = null;
      this.meioPagamentoParcial = null;
      this.descontoParcial = false;
    },
    validar() {
      if (
        !this.dataRecebimentoParcial ||
        !this.dataVencimentoParcial ||
        !this.contaParcial ||
        !this.meioPagamentoParcial ||
        !this.valorParcial
      ) {
        this.$toast.error("Preencha todos os campos necessários!");
        return false;
      }

      if (Number(this.valorParcial) >= this.valorTotal) {
        this.$toast.error(
          "O valor parcial deve ser menor que o valor total da conta."
        );
        return false;
      }

      return true;
    },
    async receberParcial() {
      if (!this.validar() || this.isSubmitting) return;

      this.isSubmitting = true;
      try {
        let resultado;

        if (this.recebimentoPdv) {
          const { data } = await this.$http.post(
            "/contareceber/pdv/receber-parcial",
            {
              id_conta_receber: this.conta.id,
              valor_parcial: this.valorParcial,
              data_vencimento: this.dataVencimentoParcial,
              data_recebimento: this.dataRecebimentoParcial,
              id_banco: this.contaParcial.id_banco,
              id_meio_pagamento: this.meioPagamentoParcial.id,
              desconto: this.descontoParcial,
            }
          );
          resultado = data?.data || data;
        } else {
          const { data: dadosParcial } = await this.$http.post(
            "/contareceber/receber-parcial",
            {
              id_conta_receber: this.conta.id,
              valor_parcial: this.valorParcial,
            }
          );
          const { data } = await this.$http.post(
            "/contareceber/create-parcial",
            {
              ...dadosParcial,
              data_vencimento: this.dataVencimentoParcial,
              data_recebimento: this.dataRecebimentoParcial,
              id_banco: this.contaParcial.id_banco,
              id_meio_pagamento: this.meioPagamentoParcial.id,
              valor_parcial: this.valorParcial,
              desconto: this.descontoParcial,
            }
          );
          resultado = data;
        }

        this.$emit("success", resultado);
        this.$bvModal.hide(this.modalId);
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
            "Não foi possível realizar o recebimento parcial."
        );
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
